/** Site monolingue : toujours le français. */
export const DEFAULT_LOCALE = 'fr' as const

export function normalizeToSupportedLocale(_code: string | null | undefined): string {
  return DEFAULT_LOCALE
}

/** Conservé pour compat ; le site n’utilise plus de préfixe de langue dans l’URL. */
export function getPreferredLocaleForRoot(): string {
  return DEFAULT_LOCALE
}
